import * as React from "react"

import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"

export function TeamSwitcher({ teams }) {
  const team = teams?.[0]
  if (!team) return null

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton size="lg" asChild>
          <a href="/" aria-label="TeachMe2 Sales">
            <div className="hidden aspect-square size-8 items-center justify-center rounded-lg text-sidebar-foreground group-data-[collapsible=icon]:flex">
              <team.logo className="size-4" />
            </div>
            <img
              src="https://publicassets.teachme2.com/www/images/svg/logo-footer.svg"
              alt="TeachMe2"
              className="h-7 w-auto group-data-[collapsible=icon]:hidden"
            />
          </a>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
